export const ColorTheme = {
    colors: {
      primary: "#1B87F4",
      secondary: "#F4A261",
    },
  };